import { Actions } from "./Actions";

export const columns = [
  {
    Header: "شناسه",
    width: 100,
    accessor: "id",
    disableFilters: true,
  },
  {
    Header: "مبلغ",
    accessor: "amount",
  },
   {
    Header: "وضعیت تراکنش",
    accessor: "statusTitle",
  },
   {
    Header: "نوع تراکنش",
    accessor: "typeTitle",
  },
  {
    Header: "تاریخ پرداخت",
    accessor: "paymentDate",
  },
  // {
  //   Header: "نوع پرداخت",
  //   accessor: "paymentTypeTilte",
  // },
  // {
  //   Header: "شماره سفارش",
  //   accessor: "orderId",
  // },
  // {
  //   Header: "شماره پیگیری",
  //   accessor: "refNum",
  // },

  // {
  //   Header: "نام شعبه",
  //   accessor: "branchName",
  // },
  // {
  //   Header: "کد شعبه",
  //   accessor: "branchCode",
  // },
   {
    Header: "عملیات",
    accessor: "operations",
    disableFilters: true,
    width: 100,
    Cell: Actions,
  },
 
];
